import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { X, Check, Ban, Clock } from "lucide-react";

const TABS = [["confirmed", "Onaylı"], ["pending", "Ödeme bekleyen"], ["waitlisted", "Bekleme listesi"], ["cancelled", "İptal"]];

export function EventRegistrations({ event, onClose }) {
  const [regs, setRegs] = useState([]);
  const [tab, setTab] = useState("confirmed");
  const [ev, setEv] = useState(event);
  const load = () => {
    api.get(`/admin/events/${event.slug}/registrations`).then(({ data }) => setRegs(data)).catch(() => toast.error("Kayıtlar yüklenemedi."));
    api.get(`/events/${event.slug}`).then(({ data }) => setEv(data)).catch(() => {});
  };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const change = async (id, status) => {
    try { await api.patch(`/admin/registrations/${id}`, { status }); toast.success("Kayıt güncellendi."); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Güncellenemedi."); }
  };
  const list = regs.filter((r) => r.status === tab).sort((a, b) => tab === "waitlisted" ? (a.position || 0) - (b.position || 0) : 0);

  return (
    <div className="fixed inset-0 bg-brand-green/50 z-50 flex justify-end" onClick={onClose}>
      <div data-testid="event-registrations-panel" className="bg-brand-offwhite w-full max-w-2xl h-full overflow-y-auto p-6 sm:p-8" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-start gap-4">
          <div>
            <p className="text-xs uppercase tracking-widest text-brand-gold font-semibold">Katılımcılar</p>
            <h3 className="font-serif text-2xl text-brand-green mt-1">{event.title}</h3>
            <p data-testid="reg-panel-capacity" className="text-sm text-brand-text/60 mt-1">{ev.capacity != null ? `Kapasite ${ev.capacity} · Boş ${ev.remaining ?? ev.capacity}` : "Sınırsız kapasite"}</p>
          </div>
          <button onClick={onClose} data-testid="event-registrations-close" aria-label="Kapat" className="text-brand-green"><X size={22} /></button>
        </div>
        <div className="flex flex-wrap gap-2 mt-6 border-b border-brand-gold-light/40 pb-3">
          {TABS.map(([v, l]) => (
            <button key={v} onClick={() => setTab(v)} data-testid={`reg-tab-${v}`} className={`text-sm px-3 py-1.5 rounded-sm transition-colors ${tab === v ? "bg-brand-green text-brand-offwhite" : "text-brand-text/70 hover:bg-brand-gold-light/20"}`}>
              {l} ({regs.filter((r) => r.status === v).length})
            </button>
          ))}
        </div>
        <div className="mt-4 space-y-3">
          {list.length === 0 && <p data-testid="reg-empty" className="text-sm text-brand-text/60 py-8 text-center">Bu listede kayıt yok.</p>}
          {list.map((r) => <RegRow key={r.id} r={r} onChange={change} />)}
        </div>
      </div>
    </div>
  );
}

function RegRow({ r, onChange }) {
  const btn = "inline-flex items-center gap-1 text-xs px-2.5 py-1.5 rounded-sm border transition-colors";
  return (
    <div data-testid={`reg-row-${r.id}`} className="border border-brand-gold-light/40 rounded-sm p-4 bg-white">
      <div className="flex justify-between gap-3 flex-wrap">
        <div>
          <p className="font-medium text-brand-green">{r.status === "waitlisted" && <span data-testid={`reg-position-${r.id}`} className="text-brand-gold mr-1">#{r.position}</span>}{r.participant_name}</p>
          <p className="text-xs text-brand-text/60 break-all">{r.participant_email}{r.participant_phone ? ` · ${r.participant_phone}` : ""}{r.participant_age ? ` · ${r.participant_age} yaş` : ""}</p>
          {r.notes && <p className="text-xs text-brand-text/70 mt-1 italic">{r.notes}</p>}
          <p className="text-[11px] text-brand-text/40 mt-1">{(r.created_at || "").slice(0, 16).replace("T", " ")}</p>
        </div>
        <div className="flex gap-2 items-start flex-wrap">
          {r.status !== "confirmed" && <button onClick={() => onChange(r.id, "confirmed")} data-testid={`reg-confirm-${r.id}`} className={`${btn} border-emerald-300 text-emerald-800 hover:bg-emerald-50`}><Check size={12} /> {r.status === "waitlisted" ? "Kontenjana al" : "Onayla"}</button>}
          {r.status !== "waitlisted" && r.status !== "cancelled" && <button onClick={() => onChange(r.id, "waitlisted")} data-testid={`reg-waitlist-${r.id}`} className={`${btn} border-brand-gold-light text-brand-text hover:bg-brand-gold-light/20`}><Clock size={12} /> Beklemeye al</button>}
          {r.status !== "cancelled" && <button onClick={() => { if (window.confirm("Kayıt iptal edilsin mi?")) onChange(r.id, "cancelled"); }} data-testid={`reg-cancel-${r.id}`} className={`${btn} border-red-200 text-red-700 hover:bg-red-50`}><Ban size={12} /> İptal</button>}
        </div>
      </div>
    </div>
  );
}
